import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {ProfessionalLiabilityService} from '../../../../domain/model/liability/professional-liability.service';
import {ProfessionalLiability} from '../../../../domain/model/liability/professional-liability.model';
import {HealthStatus} from '../../../../domain/model/liability/health-status.model';
import {FileListService} from '../../../../components/files/service/file-list.service';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import {Model} from '../../../../domain/model/common/model.class';
import {AuthService} from '../../../../components/security/authorization/auth.service';
import {Roles} from '../../../../domain/authorization/roles';
import ProjectionInformation = Model.ProjectionInformation;
import moment = require('moment');

@Component({
    template: require('./health-status-screen.component.html'),
    styles: [require('./health-status-screen.component.scss')]
})
export class HealthStatusScreenComponent {

    constructor(readonly modelService: ProfessionalLiabilityService,
                readonly route: ActivatedRoute,
                readonly fileListService: FileListService,
                readonly fileLocationFactory: FileLocationFactory,
                _authService: AuthService) {

        this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());

        _authService.user$.map(user => user !== undefined && user.hasAnyRole([Roles.ADMIN]))
            .subscribe(hasRoles => this._userIsAdmin = hasRoles);
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    dateInfoConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(20, 'year')
    };

    stepScreenModel = new StepScreenModel<ProfessionalLiability>({
        initialDataModel: new ProfessionalLiability(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel(HealthStatus.projectionInformation);
        },
        _submitDataFn: (model: ProfessionalLiability) => {
            return this.modelService.updateCurrentUserModel(model, this._userIsAdmin ? HealthStatus.adminProjectionInformation : undefined);
        }
    });

    fileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('healthStatusSupportingDocument'))
    });

    fileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('healthStatusSupportingDocuments'))
    });

    get model(): HealthStatus {
        return this.stepScreenModel.dataModel.healthStatus;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    private _refreshFilesInfo() {
        this.fileListService.list(this.fileUploaderModel.filesLocation).subscribe(files => this.fileListModel.files = files);
    }

    private _userIsAdmin: boolean = false;

    get adminDocumentsEditable(): boolean {
        return this._userIsAdmin;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/steps/health-status/health-status-screen.component.ts